import styled from 'styled-components'

import theme from '~/shared/styles/theme'

interface Props {
  $size: 'md' | 'sm'
  $variant: 'gray' | 'mint' | 'pink' | 'white'
  children?: React.ReactNode
}

function Tag({ $size, $variant, children, ...rest }: Props) {
  return (
    <Wrapper $size={$size} $variant={$variant} {...rest}>
      <span>{children}</span>
    </Wrapper>
  )
}

export default Tag

const Wrapper = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: fit-content;
  min-width: 150px;
  padding: 0 16px;

  font-family: NanumSquareNeo-Heavy, sans-serif;
  text-align: center;

  border-radius: 60px;

  ${({ $size }) => {
    switch ($size) {
      case 'sm': {
        return `
          width: fit-content;
          height: 37px;
          font-weight: 500;
          font-size: 15px;
        `
      }
      case 'md': {
        return `
          width: fit-content;
          height: 41px;
          font-weight: 500;
          font-size: 18px;
        `
      }
      default: {
        return `
        `
      }
    }
  }}
  ${({ $variant }) => {
    switch ($variant) {
      case 'gray': {
        return `
          background-color: ${theme.colors.grey_2};
          color: ${theme.colors.grey_5};
        `
      }
      case 'mint': {
        return `
          background-color: ${theme.colors.mint_2};
          color: ${theme.colors.grey_5};
        `
      }
      case 'pink': {
        return `
          background-color: ${theme.colors.pink_2};
          color: ${theme.colors.grey_5};
        `
      }
      case 'white': {
        return `
          background-color: ${theme.colors.white};
          color: ${theme.colors.grey_5};
        `
      }
      default: {
        return `
        `
      }
    }
  }}
`
